import {Drawer} from '@breuni-ui/drawer';
import {safeDefine} from "@breuni-ui/safe-define";
import {togglePageScrolling} from "../../scripts/utils.js";
import {property, query} from "lit/decorators.js";
import styles from './drawer.scss';
import {css, CSSResult, html, PropertyValues, unsafeCSS} from "lit";
import {mediaQuery} from "../../scripts/lib/mediaQuery.js";

export class EntsDrawer extends Drawer {
  @property({type: Boolean, attribute: 'show-christmas-bear', reflect: true}) showChristmasBear = false;
  @property({type: String, attribute: 'assets-host'}) assetsHost = '';

  @query('dialog') private dialogElement!: HTMLDialogElement;
  @query('.ents-bear') private bearElement!: HTMLImageElement;

  private readonly bearFiguresMobile = ['hands_up', 'points_left', 'points_right'];
  private readonly bearFiguresDesktop = ['hands_up', 'points_left', 'points_right', 'rotated_points_left'];

  static get styles(): CSSResult[] {
    return [
      Drawer.styles,
      css`${unsafeCSS(styles)}`
    ];
  }

  render() {
    if (!this.showChristmasBear) {
      return super.render();
    }

    const bearFigure = mediaQuery.up_to_M
      ? this.bearFiguresMobile[Math.floor(Math.random() * this.bearFiguresMobile.length)] // NOSONAR
      : this.bearFiguresDesktop[Math.floor(Math.random() * this.bearFiguresDesktop.length)]; // NOSONAR
    const bearImageFile = bearFigure === 'rotated_points_left' ? 'points_left' : bearFigure;

    return html`
      ${super.render()}
      <img
        src="${this.assetsHost}bewerten/pds/images/xmas/bear_${bearImageFile}.svg"
        alt=""
        class="ents-bear ${bearFigure}"
      />
    `;
  }

  public updated(changedProperties: PropertyValues) {
    super.updated(changedProperties);
    if (this.dialogElement && this.bearElement) {
      if (this.bearElement.parentElement !== this.dialogElement) {
        this.dialogElement.prepend(this.bearElement);
      }
    }
  }

  show(): void {
    this.registerCloseListener();
    togglePageScrolling(false);
    this.removeAttribute('hidden');
    super.show();
  }

  async hide(): Promise<void> {
    togglePageScrolling(true);
    this.unregisterCloseListener();
    await super.hide();
    this.setAttribute('hidden', '');
  }

  private registerCloseListener() {
    document.addEventListener('keydown', () => this.handleEsc);
    this.addEventListener('drawer:close', this.hide);
  }

  private unregisterCloseListener() {
    document.removeEventListener('keydown', () => this.handleEsc);
    this.removeEventListener('drawer:close', this.hide);
  }

  private handleEsc(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.hide();
    }
  }
}

safeDefine('ents-drawer', EntsDrawer);
